import set from 'lodash/set';

export default (state, action) => {
	const { type, payload } = action;
	switch (type) {
		case types.FIELD_CHANGE:
			set(state.values, payload.key, payload.value);
			return {
				...state,
				values: {
					...state.values,
				},
			};
		case types.FIELD_ERROR_ADD:
			set(state.errors, payload.key, payload.error);
			return {
				...state,
				errors: {
					...state.errors,
				},
				isValid: false,
			};
		case types.FIELD_ERROR_REMOVE:
			delete state.errors[payload.key];
			return {
				...state,
				isValid: Object.keys(state.errors).length > 0 ? false : true,
			};
		case types.RESET:
			return payload.state;
		case types.ON_LOAD:
			return {
				...state,
				values: {
					...state.values,
					...payload.state,
				},
			};
		case types.ON_SUBMIT_FAIL:
			return {
				...state,
				isErrored: true,
				formError: payload,
			};
		case types.ON_INVALID_FORM:
			return {
				...state,
				errors: payload,
			};
		default:
			return state;
	}
};

const types = {
	FIELD_CHANGE: 'field-change',
	FIELD_ERROR_ADD: 'field-error-add',
	FIELD_ERROR_REMOVE: 'field-error-remove',
	ON_SUBMIT_FAIL: 'on-submit-fail',
	ON_INVALID_FORM: 'on-invalid-form',
	ON_LOAD: 'on-load',
	RESET: 'reset',
};

export const actions = types;
